import { render, staticRenderFns } from "./OrganisationUserForm.vue?vue&type=template&id=15aba105&scoped=true"
import script from "./OrganisationUserForm.vue?vue&type=script&lang=js"
export * from "./OrganisationUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aba105",
  null
  
)

export default component.exports